<template>
  <a-radio-group v-model:value="valComputed" name="logisticsType" :options="options">
  </a-radio-group>
</template>
<script setup lang='ts'>
import { LogisticsType } from '@src/scripts/type'
import { computed } from 'vue'

const props = defineProps<{
  value?: LogisticsType
}>()

const emit = defineEmits(['update:value'])

const valComputed = computed({
  get() {
    return props.value
  },
  set(val) {
    emit('update:value', val)
  }
})

const options = [
  { label: '自己配送', value: LogisticsType.Self },
  { label: '一城飞客', value: LogisticsType.Yichengfeike },
]

</script>

<style lang='scss' scoped></style>